import { render, staticRenderFns } from "./CardPreferencesSidebar.vue?vue&type=template&id=5b3ca4a3&scoped=true"
import script from "./CardPreferencesSidebar.vue?vue&type=script&lang=js"
export * from "./CardPreferencesSidebar.vue?vue&type=script&lang=js"
import style0 from "./CardPreferencesSidebar.vue?vue&type=style&index=0&id=5b3ca4a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ca4a3",
  null
  
)

export default component.exports